import {Component, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NbDialogService, NbToastrService} from '@nebular/theme';

import {ActivatedRoute, Router, Params} from '@angular/router';
import {LocalDataSource} from 'ng2-smart-table';

@Component({
  selector: 'app-formularios-encuestas',
  templateUrl: './formularios-encuestas.component.html',
  styleUrls: ['./formularios-encuestas.component.scss']
})
export class FormulariosEncuestasComponent implements OnInit {

  /*  Para el modal */
  @ViewChild('dialog', {static: true}) dialog: ElementRef;
  spinerEdit = false;
  /*****/
  settings = {
    hideSubHeader: true,
    actions: {
      delete: false,
      edit: false,
      add: false,
      filter: false,
      custom: [
        {name: 'detalle', title: '<i class="nb-search"></i>'}
      ],
    },
    columns: {
      nombreUsuario: {title: 'Nombre usuario'},
      apellidoUsuario: {title: 'Apellido Usuario'},
      formularioNombre: {title: 'Formulario realizado'}
    }
  };

  datos: any[];
  encuesta: any[];

  public source: LocalDataSource;
  constructor(private toastrService: NbToastrService,
              public router: Router,
              private dialogService: NbDialogService,
              private rutaActiva: ActivatedRoute) {
    // Objeto modelo para ver encuestas por usuarios.
    this.encuesta = [
      {idencuesta: 1,usuario:1,nombreUsuario: 'Nicolas',apellidoUsuario: 'Rojas',formularioNombre: 'Formulario Ejemplo',formularioID: 1, preguntas:[{pregunta:'Indique los Mts2 que tiene el terreno', seccion:'Seccion1',tipo:'Unica',respuesta:[{opcion:'Verde',puntos:5}]},{pregunta:'Cuanto es 2 x 2', seccion:'Seccion2',tipo:'Multiple',respuesta:[{opcion:4,puntos:5}]}]},
      {idencuesta: 2,usuario:2,nombreUsuario: 'David',apellidoUsuario: 'Lancheros',formularioNombre: 'Formulario Ejemplo 2',formularioID: 2, preguntas:[{pregunta:'Indique los Mts2 que tiene el terreno', seccion:'Seccion1',tipo:'Unica',respuesta:[{opcion:'Verde',puntos:5}]},{pregunta:'Cuanto es 2 x 2', seccion:'Seccion2',tipo:'Multiple',respuesta:[{opcion:4,puntos:5}]}]}
    ];
    console.log(this.encuesta);
    this.source = new LocalDataSource(this.encuesta);
  }

  ngOnInit() {
  }

  /** Para modal **/

  crear() {
    this.openDialogSave(this.dialog);
  }

  openDialogSave(dialog) {
    this.dialogService.open(dialog, { context: 'this is some additional data passed to dialog' });
  }

  accion() {
    this.spinerEdit = true;
    const TIME_IN_MS = 3000;
    setTimeout(() => {
      this.spinerEdit = false;
      this.showToast('top-right', 'success', 'Éxito!', 'Se ejecuto éxito!');
      const element: HTMLElement = document.getElementById('btn-close') as HTMLElement;
      element.click();
    }, TIME_IN_MS);
  }
  onCustom(event) {
    switch (event.action) {
        case 'detalle':
           this.verFormulario(event.data.idencuesta);
            break;
  
    }
  }
  verFormulario(id){
    this.router.navigate(['dashboard/resultados',id]);
  }
  /** Toas **/
  showToast(position, status, titulo, mensaje) {
    this.toastrService.show(
      mensaje,
      titulo,
      { position, status });
  }

}
